import { Outlet } from 'react-router-dom';


export const AdminRootLayout: React.FC = () => {
  return <Outlet />;
};
